import { render } from "./VsAvatar.vue?vue&type=template&id=266ef88e"
import script from "./VsAvatar.vue?vue&type=script&lang=js"
export * from "./VsAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__